import { useEffect, useState } from 'react';
import { EventName } from '@/shared/event-types';
import { useRouter } from 'next/router';

export type RandomAdModel = {
  title: string;
  desc: string;
  imgUrl_pc: string;
  imgUrl_mb: string;
  imgUrl_card: string;
  link: string;
  gaLabel: string;
};

const adList: RandomAdModel[] = [
  {
    title: 'Recent Follower Tracker',
    desc: 'Fast, Easy, Accurate. See Who Someone Recently Followed on Instagram.',
    imgUrl_pc: '/images/view-instagram-anonymously/ad-img/banner-pc-1.png',
    imgUrl_mb: '/images/view-instagram-anonymously/ad-img/banner-mb-1.png',
    imgUrl_card: '/images/view-instagram-anonymously/ad-img/card-1.png',
    link: '/instagram-new-follow-tracker',
    gaLabel: EventName.banner_recent_follow_cta_click,
  },
  {
    title: 'Unfollowers Tracker',
    desc: 'Find out who unfollowed you on Instagram – quick and simple.',
    imgUrl_pc: '/images/view-instagram-anonymously/ad-img/banner-pc-2.png',
    imgUrl_mb: '/images/view-instagram-anonymously/ad-img/banner-mb-2.png',
    imgUrl_card: '/images/view-instagram-anonymously/ad-img/card-2.png',
    link: '/instagram-unfollowers-tracker',
    gaLabel: EventName.banner_unfollowers_cta_click,
  },
  {
    title: 'Follower Export',
    desc: 'Easily export Instagram followers or following from any public account.',
    imgUrl_pc: '/images/view-instagram-anonymously/ad-img/banner-pc-3.png',
    imgUrl_mb: '/images/view-instagram-anonymously/ad-img/banner-mb-3.png',
    imgUrl_card: '/images/view-instagram-anonymously/ad-img/card-3.png',
    link: '/ig-follower-export-tool',
    gaLabel: EventName.banner_follower_export_cta_click,
  },
  {
    title: 'Comment Viewer & Exporter',
    desc: 'View and download Instagram post comments instantly.',
    imgUrl_pc: '/images/view-instagram-anonymously/ad-img/banner-pc-4.png',
    imgUrl_mb: '/images/view-instagram-anonymously/ad-img/banner-mb-4.png',
    imgUrl_card: '/images/view-instagram-anonymously/ad-img/card-4.png',
    link: '/instagram-viewer/post-comments',
    gaLabel: EventName.banner_post_comment_cta_click,
  },
];

function getItem(index: number) {
  return adList[index];
}

const pages = ['/anonymous-instagram-story-viewer'];

export default function useRandomAd() {
  const router = useRouter();
  const [randomAd, setRandomAd] = useState<RandomAdModel | null>(null);

  useEffect(() => {
    // 只在客户端执行随机逻辑
    if (pages.includes(router.pathname)) {
      const randomNum = Math.floor(Math.random() * 4);
      setRandomAd(getItem(randomNum));
    } else {
      setRandomAd(null);
    }
  }, [router.pathname]);

  return randomAd;
}
